import { getType } from 'typesafe-actions';
import { ImportedOrganizationActions, importedOrganizationActions } from '../../actions/creators';
import { ImportedOrganization } from '../../../types/importedOrganization';

const importedOrganizationReducer = (
  state: ImportedOrganization[] | null = null,
  action: ImportedOrganizationActions
) => {
  switch (action.type) {
    case getType(importedOrganizationActions.getImportedOrganizationsRequest.success):
      return action.payload.items;

    case getType(importedOrganizationActions.approveImportedOrganizationRequest.success):
      return action.payload !== null ? (state ? [...state, action.payload] : [action.payload]) : state;

    default:
      return state;
  }
};

export default importedOrganizationReducer;
